<template>
    <div class="card card-body card-custom gutter-b">
        <div class="row">
            <div class="col-xl-4 mb-3">
                <div class="d-flex align-items-center">
                    <span
                        class="label label-light-danger label-lg label-inline font-weight-bolder mr-5 col-3"
                    >
                        RED
                    </span>
                    <div class="d-flex flex-column font-weight-bold">
                        <a class="text-dark text-hover-primary mb-1 font-size-lg">Hard Hashtags</a>
                        <span class="text-muted"
                            >Hashtags in red are difficult to rank on based on your number of
                            likes</span
                        >
                    </div>
                </div>
            </div>
            <div class="col-xl-4 mb-3">
                <div class="d-flex align-items-center">
                    <span
                        class="label label-light-warning label-lg label-inline font-weight-bolder mr-5 col-3"
                    >
                        ORANGE
                    </span>
                    <div class="d-flex flex-column font-weight-bold">
                        <a class="text-dark text-hover-primary mb-1 font-size-lg"
                            >Average Hashtags</a
                        >
                        <span class="text-muted"
                            >Hashtags in orange are moderately difficult to rank on based on your
                            number of likes</span
                        >
                    </div>
                </div>
            </div>
            <div class="col-xl-4 mb-3">
                <div class="d-flex align-items-center">
                    <span
                        class="label label-light-success label-lg label-inline font-weight-bolder mr-5 col-3"
                    >
                        GREEN
                    </span>
                    <div class="d-flex flex-column font-weight-bold">
                        <a class="text-dark text-hover-primary mb-1 font-size-lg">Easy Hashtags</a>
                        <span class="text-muted"
                            >Hashtags in green are easy to rank on based on your number of
                            likes</span
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LikesLegend",
};
</script>
